export default {
    booking: {}
}